// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3PnDH","cell":"ColumnAccessor_cell__27fBO","firstCellAccent":"ColumnAccessor_firstCellAccent__8h3rr"};